export const START_YEAR = 1900;
